<div class="category-selector">
  <label class="spen-mod-select">
    <select class="select" data-cy="activity-category" [class.unselect-option]="isUnselectCategory" (change)="onChangeCategory($event)">
      <option class="is-all-point select-option" [value]="null" [selected]="isSelectedCategory(null)">
        {{ emptyLabel }}
      </option>
      @for (category of categories; track category.id) {
        <option class="is-part-point select-option" [value]="category.id" [selected]="isSelectedCategory(category)">
          {{ category.name }}
        </option>
      }
    </select>
    <i class="fa fa-caret-down"></i>
  </label>
  <label class="spen-mod-select">
    <select
      class="select"
      data-cy="sub-activity-category"
      [disabled]="isNoSubCategories()"
      [class.unselect-option]="isUnselectSubCategory"
      (change)="onChangeSubCategory($event)"
    >
      <option class="is-all-point select-option" [value]="null" [selected]="isSelectedSubCategory(null)">
        {{ emptyLabel }}
      </option>
      @for (subCategory of subCategories; track subCategory) {
        <option class="is-part-point select-option" [value]="subCategory.id" [selected]="isSelectedSubCategory(subCategory)">
          {{ subCategory.name }}
        </option>
      }</select
    ><i class="fa fa-caret-down"></i>
  </label>
</div>
